var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-2-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.25C9.175 3.25 8.5 3.925 8.5 4.75C8.5 5.575 9.175 6.25 10 6.25C10.825 6.25 11.5 5.575 11.5 4.75C11.5 3.925 10.825 3.25 10 3.25ZM10 13.75C9.175 13.75 8.5 14.425 8.5 15.25C8.5 16.075 9.175 16.75 10 16.75C10.825 16.75 11.5 16.075 11.5 15.25C11.5 14.425 10.825 13.75 10 13.75ZM10 8.5C9.175 8.5 8.5 9.175 8.5 10C8.5 10.825 9.175 11.5 10 11.5C10.825 11.5 11.5 10.825 11.5 10C11.5 9.175 10.825 8.5 10 8.5Z",
    fill: "#525866"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.1cbe742a8335dcdee3c3a252b112b4bc.svg";
export { ForwardRef as ReactComponent };